import { render, staticRenderFns } from "./Uptime_chart.vue?vue&type=template&id=2fe87f0a&scoped=true&"
import script from "./Uptime_chart.vue?vue&type=script&lang=js&"
export * from "./Uptime_chart.vue?vue&type=script&lang=js&"
import style0 from "./Uptime_chart.vue?vue&type=style&index=0&id=2fe87f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe87f0a",
  null
  
)

export default component.exports